var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { emailSvg, externalLinkSvg, phoneSvg, showOnMapSvg, } from '../helpers/elements.js';
import { empty, normalizePhoneNumber, truncate, prettifyUrl, } from '../helpers/string.js';
import { classMap } from 'lit/directives/class-map.js';
import { Accommodation, Bicycle, Bookable } from '../apis/api-poi.js';
import { ifDefined } from 'lit/directives/if-defined.js';
let ElementAddress = class ElementAddress extends LitElement {
    constructor() {
        super(...arguments);
        this.bigOverlay = false;
        this.inPopup = false;
    }
    showOnMap(item) {
        const showOnMapDetail = {
            type: item instanceof Bicycle ? item.type : 'accommodation',
            id: item.id,
            refid: item.refid,
            types: item instanceof Accommodation
                ? item.types
                : undefined,
        };
        this.dispatchEvent(new CustomEvent('showOnMap', {
            detail: showOnMapDetail,
            bubbles: true,
            composed: true,
        }));
    }
    render() {
        if (!this.item)
            return '';
        return html `
      <div
        class="${classMap({
            body: this.bigOverlay,
            flex: !this.bigOverlay,
            'flex-col': !this.bigOverlay,
            'gap-y-[2px]': !this.bigOverlay,
        })} not-italic"
      >
        ${this.bigOverlay
            ? html ` <div>${this.item.addressName}</div>
                <div>${this.item.addressName2}</div>
                <div>${this.item.addressStreet}</div>
                <div>${this.item.addressZip} ${this.item.addressCity}</div>` : ''}
        <div
          class="${classMap({
            'gap-y-[2px]': !this.bigOverlay,
            'gap-y-[12px]': this.bigOverlay,
            'mt-[12px]': this.bigOverlay,
        })} flex flex-col"
        >
          <div
            data-cy="poi-phone"
            class="${classMap({
            'poi-address-item': !this.bigOverlay,
            hidden: empty(this.item.addressPhone),
        })}"
          >
            <a
              class="group flex w-full items-center link-with-icon-in-context clickable-icon-with-text"
              href="tel:${normalizePhoneNumber(this.item.addressPhone)}"
            >
              <div>${phoneSvg('clickable-icon-in-group')}</div>
              <span class="overflow-hidden text-ellipsis whitespace-nowrap"
                >${this.item.addressPhone}</span
              >
            </a>
          </div>
          <div
            data-cy="poi-mobile"
            class="${classMap({
            'poi-address-item': !this.bigOverlay,
            hidden: empty(this.item.addressMobile),
        })}"
          >
            <a
              class="group flex w-full items-center link-with-icon-in-context clickable-icon-with-text"
              href="tel:${normalizePhoneNumber(this.item.addressMobile)}"
            >
              <div>${phoneSvg('clickable-icon-in-group')}</div>
              <span class="overflow-hidden text-ellipsis whitespace-nowrap"
                >${this.item.addressMobile}</span
              >
            </a>
          </div>
          <div
            data-cy="poi-email"
            class="${classMap({
            'poi-address-item': !this.bigOverlay,
            hidden: empty(this.item.addressEmail),
        })}"
          >
            <a
              class="group flex w-full items-center link-with-icon-in-context clickable-icon-with-text"
              href="mailto:${this.item.addressEmail}"
            >
              <div>${emailSvg('clickable-icon-in-group')}</div>
              <span class="overflow-hidden text-ellipsis whitespace-nowrap"
                >${this.item.addressEmail}</span
              >
            </a>
          </div>
          <div
            data-cy="poi-url"
            class="${classMap({
            'poi-address-item': !this.bigOverlay,
            hidden: !this.item.addressUrl || this.item instanceof Bookable,
        })}"
          >
            <a
              class="group flex w-full items-center link-with-icon-in-context clickable-icon-with-text"
              href=${ifDefined(this.item.addressUrl)}
              target="_blank"
              rel="noopener"
            >
              <div>
                ${externalLinkSvg({
            classes: 'clickable-icon-in-group',
        })}
              </div>
              <span class="overflow-hidden text-ellipsis whitespace-nowrap">
                ${this.item.addressUrlText ||
            truncate(prettifyUrl(this.item.addressUrl))} </span
              ><span class="screen-reader-only"
                >(wird in neuem Tab ge\u00F6ffnet)</span
              >
            </a>
          </div>
          ${(this.item instanceof Accommodation ||
            this.item instanceof Bookable) &&
            this.item.urlBookingLink
            ? html ` <div
                  data-cy="poi-booking-url"
                  class="poi-address-item ${classMap({
                hidden: !this.item.urlBookingLink,
            })}"
                >
                  <a
                    class="group flex w-full items-center link-with-icon-in-context clickable-icon-with-text"
                    href="${this.item.urlBookingLink}"
                    target="_blank"
                    rel="noopener"
                  >
                    <div>
                      ${externalLinkSvg({
                classes: 'clickable-icon-in-group',
            })}
                    </div>
                    <span
                      class="overflow-hidden text-ellipsis whitespace-nowrap"
                    >
                      ${this.item.urlBookingText ||
                truncate(prettifyUrl(this.item.urlBookingLink))}
                    </span>
                    <span class="screen-reader-only"
                      >(wird in neuem Tab ge\u00F6ffnet)</span
                    >
                  </a>
                </div>` : ''}
          ${!this.inPopup &&
            (this.item instanceof Accommodation || this.item instanceof Bicycle)
            ? html ` <div
                  class="poi-address-item cursor-pointer"
                  @click="${() => this.showOnMap(this.item)}"
                >
                  <div
                    class="group flex w-full items-center link-with-icon-in-context clickable-icon-with-text"
                  >
                    <div>${showOnMapSvg('clickable-icon-in-group')}</div>
                    <span class="overflow-hidden"> auf Karte anzeigen </span>
                  </div>
                </div>` : ''}
        </div>
      </div>
    `;
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    property({ type: Object })
], ElementAddress.prototype, "item", void 0);
__decorate([
    property({ type: Boolean })
], ElementAddress.prototype, "bigOverlay", void 0);
__decorate([
    property({ type: Boolean })
], ElementAddress.prototype, "inPopup", void 0);
ElementAddress = __decorate([
    customElement('element-address')
], ElementAddress);
export default ElementAddress;
//# sourceMappingURL=element-address.js.map